export const en = {
  externalSso: {
    title: "Continue with your organization's sign-in",
    description:
      'A window will open so you can sign in with your identity provider. Come back here once it closes.',
    returnToOriginalWindow:
      'Return to the window where you started signing in to continue.',
    popupBlocked:
      'Your browser blocked the sign-in window. Allow pop-ups for this site and try again.',
  },
  common: {
    signOut: 'Sign Out',
    cancel: 'Cancel',
    save: 'Save',
    loading: 'Loading...',
    error: 'An error occurred',
    success: 'Success',
    continue: 'Continue',
    email: 'Email',
    getStarted: 'Get Started',
    retry: 'Retry',
    verify: 'Verify',
  },
  profile: {
    title: 'Profile',
    account: 'Account',
    email: 'Email',
    language: 'Language',
    theme: {
      title: 'Theme',
      light: 'Light',
      dark: 'Dark',
    },
    languages: {
      en: 'English',
      he: 'Hebrew',
    },
  },
  home: {
    welcomeBack: 'Welcome back!',
    signedInAs: "You're signed in as",
  },
  auth: {
    loginError: 'Error during login, please reload the page and try again.',
    cannotLogInAsUser: "Can't log in as this user",
    emptyEmail: 'Please enter your email address',
    invalidEmail: 'Please enter a valid email address',
    enterSparkAccountUsername: 'Enter your account username',
    loginToYourAccount: 'Login to your account',
    signInTo: 'Sign in to',
    username: 'Username',
    next: 'Next',
    requestApproved: 'Request Approved',
    enterEmail: 'Enter your email',
    magicLinkInfo: "We'll send you a magic link to sign in",
    emailPlaceholder: 'your@email.com',
    continue: 'Continue',
    verifyingEmail: 'Verifying your email',
    pleaseWait: 'Please wait while we verify your email address',
    success: 'Success!',
    nowSignedIn: "You're now signed in as",
    continueToApp: 'Continue to App',
    email: 'Email',
    password: 'Password',
    enterPassword: 'Enter your password',
    enterPasswordFor: 'Enter your password for',
    forgotPassword: 'Forgot Password?',
    emailRequired: 'Email is required',
    passwordRequired: 'Password is required',
    invalidCredentials: 'Invalid credentials',
    checkCredentials: 'Please check your email and password and try again.',
    signIn: 'Sign-In to NewCore',
    signingIn: 'Signing In...',
    approveTitle: 'Approve on Device',
    checkDevice: 'Check your device',
    approvePrompt: 'Please approve the login request',
    requestRejected: 'Login request was rejected',
    tryAgain: 'Try Again',
    samlError: 'Error processing authentication response',
    genericError: 'An error occurred. Please try again.',
    networkError:
      'Network connection error. Please check your connection and try again.',
    errors: {
      emptyEmail: 'Please enter your email address',
      invalidEmail: 'Please enter a valid email address',
      generic: 'Something went wrong. Please try again.',
    },
    challengeFailed: 'Authentication challenge failed',
    challengeNotFound: 'Authentication challenge not found',
    invalidRequest: 'Invalid Request',
    missingParameters:
      'Missing required authentication parameters. Please restart the login process.',
  },
  notifications: {
    testButton: 'Test Notification',
    title: 'Test Notification',
    body: 'This is a test notification from NewCore!',
    requestPermission: 'Enable Notifications',
    tokenAvailable: 'Push token available',
  },
  mfa: {
    error: 'An error occurred. Please try again.',
    fetchError: 'Failed to load request details',
    networkError:
      "Couldn't reach the server. Check your connection and try again.",
    invalidRequest: 'Invalid Request',
    loading: 'Loading request details...',
    genericError: 'Failed to load request details',
    approved: 'Approved',
    approvedMessage: 'You have successfully approved this login request.',
    declined: 'Declined',
    declinedMessage: 'You have declined this login request.',
    noRequestDetails: 'No request details available',
    requestingAccess: 'is requesting access',
    user: 'User',
    location: 'Location',
    device: 'Device',
    time: 'Time',
    confirmIdentity: 'Please confirm this is you attempting to sign in',
    decline: 'Decline',
    approve: 'Approve',
    challengeFailed: 'Authentication challenge failed',
    challengeNotFound: 'Authentication challenge not found',
    autoActionError: 'Failed to automatically process the request',
    resendNotification: 'Resend',
    resendError: 'Failed to resend notification. Please try again.',
    unsupportedFactor: 'Unsupported Authentication Method',
    unsupportedFactorMessage:
      "The authentication method '{{factorType}}' is not supported yet. Please contact your administrator.",
    maxRetriesExceeded:
      'Maximum retry attempts exceeded. Please try again later.',
    waitingForApproval: 'Waiting for Approval',
    checkYourDevice: 'Check your device for the approval notification',
    resendAvailableSoon: 'You can resend the notification in a few seconds',
    loginApproved: 'Login request approved successfully',
    loginDeclined: 'Login request has been declined',
    canCloseWindow: 'You can now close this window',
    loginDetails: 'Login Details',
    ipAddress: 'IP Address',
    expired: 'Request Expired',
    requestExpired:
      'The authentication request has expired. Please try logging in again.',
    redirecting: 'Redirecting...',
    noDeviceRegistered: 'No Device Registered',
    noDeviceMessage:
      'No device is registered for push notifications. Please register a device first.',
    registerDeviceHint:
      'Install the device auth app and enable notifications to use this authentication method.',
    processingApproval: 'Processing Approval',
    completingAuthentication: 'Completing authentication flow...',
    checkYourSparkApp: 'Check Your NewCore App',
    notificationSentMessage:
      'We sent a notification to your device.\nTap Yes on the notification to continue.',
    visualMatchMessage:
      'We sent a notification to your device.\nChoose this picture on your mobile device to continue.',
    visualMatchImageAlt: 'Visual match challenge on your device',
    imageLoadError: 'Failed to load image',
    didntReceiveIt: "Didn't receive it?",
    requestNewCodeIn: 'Request new code in',
    whatsappTitle: 'Check your WhatsApp',
    whatsappMessage: 'Enter the 6-digit code sent to your WhatsApp',
    codeSentTo: 'Code sent to {{phone}}',
    enterCode: 'Enter verification code',
    invalidCode: 'Invalid code. Please try again.',
    codeExpired: 'Code expired. Please request a new one.',
    tooManyAttempts: 'Too many attempts. Please try again later.',
    resendCode: 'Resend code',
    resendLimitReached: "You've reached the resend limit.",
    verifyUsingTotp: 'Verify using Authenticator App',
  },
};
